<div class="alerts-header">
  <h3 class="alerts-title">{{ 'Alerts' | translate }}</h3>

  <div class="controls">
    <button
      mat-icon-button
      ixTest="settings-menu"
      [title]="'Settings' | translate"
      [matMenuTriggerFor]="alertSettingsMenu"
    >
      <ix-icon name="settings"></ix-icon>
    </button>
    <mat-menu #alertSettingsMenu="matMenu">
      <a mat-menu-item ixTest="alert-settings" (click)="navigateTo(['/system', 'alert-settings'])">
        {{ 'Alert Settings' | translate }}
      </a>
      <a mat-menu-item ixTest="email-settings" (click)="navigateTo(['/system', 'general'], { fragment: 'email' })">
        {{ 'Email' | translate }}
      </a>
    </mat-menu>
    <button
      mat-icon-button
      ixTest="close-panel"
      [title]="'Close panel' | translate"
      (click)="onPanelClosed()"
    >
      <ix-icon name="clear"></ix-icon>
    </button>
  </div>
</div>

<div *ngIf="isLoading$ | async; else loaded">
  <mat-progress-bar
    class="loading-indicator"
    color="primary"
    mode="indeterminate"
  ></mat-progress-bar>
</div>
<ng-template #loaded>
  <!-- TODO: Consider extracting into its own component -->
  <div *ngIf="error$ | async as error" class="error">
    <ix-icon class="icon" color="accent" name="cancel"></ix-icon>
    <h4 class="message">
      <span class="error-word">{{ 'Error:' | translate }}</span>
      {{ error }}
    </h4>
  </div>

  <div *appLet="unreadAlerts$ | async as unreadAlerts">
    <div *ngIf="!unreadAlerts.length; else hasUnreadAlerts" class="no-alerts">
      <ix-icon class="icon" name="info"></ix-icon>
      <h4 class="message">{{ 'There are no alerts.' | translate }}</h4>
    </div>

    <ng-template #hasUnreadAlerts>
      <div class="alert-list unread-alerts">
        <div
          *ngFor="let alert of unreadAlerts; last as last; trackBy: trackByAlertId"
          class="alert"
          role="listitem"
          [class.alert-last]="last"
        >
          <ix-alert [alert]="alert" [isHaLicensed]="isHaLicensed"></ix-alert>
        </div>
      </div>

      <button
        matRipple
        class="button-row"
        ixTest="dismiss-all-alerts"
        (click)="onDismissAll()"
      >
        {{ 'Dismiss All Alerts' | translate }}
      </button>
    </ng-template>
  </div>

  <div *appLet="dismissedAlerts$ | async as dismissedAlerts">
    <ng-container *ngIf="dismissedAlerts.length">
      <div class="alert-list dismissed-alerts">
        <div
          *ngFor="let alert of dismissedAlerts; last as last; trackBy: trackByAlertId"
          class="alert"
          role="listitem"
          [class.alert-last]="last"
        >
          <ix-alert [alert]="alert" [isHaLicensed]="isHaLicensed"></ix-alert>
        </div>
      </div>

      <button
        class="button-row"
        matRipple
        ixTest="reopen-all-alerts"
        (click)="onReopenAll()"
      >
        {{ 'Re-Open All Alerts' | translate }}
      </button>
    </ng-container>
  </div>
</ng-template>
